import {
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography,
} from "@mui/material";
import { ALIGNMENT_OPTIONS } from "../utils/DefaultConfigWitness";
export const AlignmentSelector = ({ value, onChange }) => (
  <FormControl component="fieldset">
    <RadioGroup row value={value} onChange={(e) => onChange(e.target.value)}>
      {ALIGNMENT_OPTIONS.map(({ value: val, label }) => (
        <FormControlLabel
          key={val}
          value={val}
          control={<Radio size="small" sx={{ color: "#1976d2" }} />}
          label={<Typography variant="body2">{label}</Typography>}
        />
      ))}
    </RadioGroup>
  </FormControl>
);